<template>
  <nuttrema-layout-form-standard :edit="true" :saveError="ProgramDetails.saveError" theme="west-top">
    <template slot="center">
      <el-form
         label-position="top"
        :ref="formRef"
        :model="formData"
        :rules="rules"
        :validate-on-rule-change="false">

        <section class="is-have-help">
          <p class="section-title">{{ $t('label.main_information') }}</p>
          <div class="section-items">
            <el-form-item :label="$t('label.name')" prop="name">
              <el-col :span="24">
                <el-input v-model="formData.name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item
               prop="duration"
               class="el-form-item--remove-line-height"
              :label="$t('label.duration_days')">
              <el-col :span="12">
                <el-input-number v-model="formData.duration" :min="1" size="medium" class="w-100"></el-input-number>
              </el-col>
            </el-form-item>
            <el-form-item
              :label="$t('label.description')"
               prop="description"
               class="el-form-item--remove-line-height">
              <el-col :span="24">
                <el-input
                   class="w-100"
                   type="textarea"
                   v-model="formData.description"
                  :autosize="{ minRows: 3, maxRows: 10 }">
                </el-input>
              </el-col>
            </el-form-item>
          </div>

          <div class="section-help">
            <p>{{ $t('label.maximum_program_duration', { upper_limit: _get(InstanceSubscribedPlanSummarized, 'data.subscribed_plan.program_duration.upper_limit') }) }}</p>
          </div>
        </section>

      </el-form>
    </template>

    <template slot="footer">
      <div class="footer-row">
        <el-button type="primary" size="small" @click="submitForm" :loading="isSaving">{{ $t('label.create') }}</el-button>
        <el-button type="text" size="small" @click="cancelChanges(false)">{{ $t('label.cancel') }}</el-button>
      </div>
    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
/* eslint-disable object-shorthand */
import { clone, get } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

export default {
  name: 'form-create-diet-basic-information',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    ProgramDetails: {
      required: true,
      default: null,
    },
    InstanceSubscribedPlanSummarized: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        name: null,
        duration: 1,
        description: null,
      },
    };
  },
  computed: {
    rules() {
      const max = get(this.InstanceSubscribedPlanSummarized, 'data.subscribed_plan.program_duration.upper_limit');
      return {
        name: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.name', true),
          },
        ],
        duration: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.duration', true),
          },
          {
            min: 1,
            max: Number(max),
            type: 'number',
            trigger: 'blur',
            message: this.formatValidationMessage('validation.program_duration_max_limit'),
          },
        ],
      };
    },
  },
  methods: {
    getFormData() {
      return clone(this.formData);
    },
  },
  created() {
    this.stateData = this.ProgramDetails;
    this.formRef = 'create-program-basic-information';
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/diets/details/create-diet/form-create-diet-basic-information.vue